import type { Gateway } from '@modules/gateways'

import { gatewayMatchesProjectKey } from './gatewayMatchesProjectKey'

export function countGatewaysForProjectKey(gateways: Gateway[], projectKeyId: string): number {
  const normalizedProjectKeyId = projectKeyId.trim()

  if (!normalizedProjectKeyId) {
    return 0
  }

  return gateways.filter((gateway) => gatewayMatchesProjectKey(gateway, normalizedProjectKeyId)).length
}
